import { render, staticRenderFns } from "./TransactionsDetails.vue?vue&type=template&id=6f1f7ce3&"
import script from "./TransactionsDetails.vue?vue&type=script&lang=ts&"
export * from "./TransactionsDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports